import { CreditCard, Calendar, Sword } from "lucide-react";

const steps = [
  {
    icon: CreditCard,
    step: "1",
    title: "Buy Your Pass",
    description: "One simple purchase for 5 action-packed days of fencing fun.",
    color: "bg-[#0A1A2F]",
  },
  {
    icon: Calendar,
    step: "2",
    title: "Choose Your Days",
    description: "Pick any 5 school-holiday sessions within 12 months. Mix and match as you like!",
    color: "bg-[#D4A857]",
  },
  {
    icon: Sword,
    step: "3",
    title: "Come Along & Fence!",
    description: "Show up, have fun, learn new skills, and make friends.",
    color: "bg-[#3FA9F5]",
  },
];

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="py-20 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0A1A2F]/10 text-[#0A1A2F] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            Simple & Flexible
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-4 font-['Montserrat']">
            How the <span className="text-[#D4A857]">5-Day Pass</span> Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-['Lato']">
            Getting started is easy! Just three simple steps to begin your fencing adventure.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, i) => (
            <div
              key={i}
              className="relative bg-white rounded-lg p-8 border-2 border-[#F4F4F4] hover:border-[#D4A857]/30 hover:shadow-xl transition-all text-center group"
              data-testid={`step-${i}`}
            >
              {/* Step Number */}
              <div className={`${step.color} w-16 h-16 rounded-lg flex items-center justify-center mx-auto mb-6 text-white shadow-lg group-hover:scale-110 transition-transform`}>
                <step.icon size={32} />
              </div>
              
              {/* Step Badge */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#0A1A2F] text-white px-4 py-1 rounded text-sm font-bold font-['Montserrat']">
                Step {step.step}
              </div>
              
              <h3 className="text-xl font-bold text-[#0A1A2F] mb-3 font-['Montserrat']">{step.title}</h3>
              <p className="text-gray-600 font-['Lato']">{step.description}</p>
              
              {/* Connector Arrow (desktop only) */}
              {i < 2 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 text-[#D4A857] text-2xl z-10">
                  →
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Flexibility Note */}
        <div className="bg-[#0A1A2F] rounded-lg p-8 text-white relative overflow-hidden">
          <div className="relative z-10 text-center">
            <h3 className="text-2xl font-bold text-[#D4A857] mb-4 font-['Montserrat']">Total Flexibility for Busy Families</h3>
            <p className="text-white/90 max-w-3xl mx-auto text-lg leading-relaxed font-['Lato']">
              Your pass is valid for <span className="font-bold text-white">12 months from purchase</span>. 
              Mix and match days across February Half Term, Easter, May Half Term, Summer Holidays, 
              October Half Term, and more. Choose your days as you go!
            </p>
            
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              {["Feb Half Term", "Easter", "May", "Summer", "October", "Christmas"].map((holiday, i) => (
                <span key={i} className="bg-white/10 px-4 py-2 rounded text-sm font-medium border border-white/20 font-['Lato']">
                  {holiday}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
